/**
 * Tier-Based Limits — single source of truth for seat and entry caps per subscription tier.
 *
 * Import these helpers wherever you need to enforce or display a limit.
 */

export const TIER_LIMITS = {
    demo: { seats: 2, entries: 5 },
    standard: { seats: 5, entries: 10_000 },
    pro: { seats: 10, entries: 100_000 },
};

/** Maximum number of team members (seats) for a given tier. */
export const getSeatLimit = (tier) => {
    const normalized = tier?.replace('manual_', '')?.toLowerCase();
    return TIER_LIMITS[normalized]?.seats ?? TIER_LIMITS.demo.seats;
};

/** Maximum number of emission entries for a given tier. */
export const getEntryLimit = (tier) => {
    const normalized = tier?.replace('manual_', '')?.toLowerCase();
    return TIER_LIMITS[normalized]?.entries ?? TIER_LIMITS.demo.entries;
};

/** Format a limit number for display (e.g. 10000 → "10,000"). */
export const formatLimit = (n) => n.toLocaleString('en-AU');
